import React, {useState, useContext} from 'react';
import {Context} from '../../context';

function HeadingAndExpandableBody(props) {
  const [expanded, setExpanded] = useState(props.expanded);
  const {localeText} = useContext(Context);

  return (
    <div className='w-full border border-b-0 last:border-b border-gray-400'>
      <div>
        <div
          id={
            props.headingAndExpandableBodyId &&
            `click-to-expand-hide-section-${props.headingAndExpandableBodyId}`
          }
          className='w-full p-4 flex justify-between items-baseline cursor-pointer border-white hover:border-gray-400 border hover:bg-lightGray2'
          onClick={() => setExpanded(prev => !prev)}
        >
          <div className='p-2 text-xl'>{props.heading}</div>
          <div className='flex flex-no items-center'>
            {expanded ? (
              <React.Fragment>
                {localeText('rw_title_hide', 'Hide')}
                <i className='fa-sharp fa-solid fa-caret-up text-2xl ml-2'></i>
              </React.Fragment>
            ) : (
              <React.Fragment>
                {localeText('rw_title_expand', 'Expand')}
                <i className='fa-sharp fa-solid fa-caret-down text-2xl ml-2'></i>
              </React.Fragment>
            )}
          </div>
        </div>
        {expanded && (
          <div className='w-full p-4 bg-lightGray2'>{props.children}</div>
        )}
      </div>
    </div>
  );
}

export default HeadingAndExpandableBody;
